export const REQUEST_ID_HEADER_KEY = "X-Request-Id";

export const AI_ANSWER_FEEDBACK_SCOPE = "ai-generated-answer";
